// i18n
import Link from 'presentations/views/components/atoms/Link';
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import locationTypeTranslations from 'infras/i18n/locales/location_type.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  black,
  gray01,
  gray04,
  primary,
  white,
} from 'presentations/views/styles/color';
import { fontSize, spacing } from 'presentations/views/styles';
import { getDateTime } from 'infras/datetime';
import { PaymentMethod } from 'domains/models/event_payment/payment_method';
import PaymentDetail from 'presentations/views/components/molecules/PaymentDetail';
import { EventDetailItem } from 'presentations/api/schema/event';
import { stripeConnectPaymentIntentPath } from 'presentations/routes/path';

interface Props {
  event: EventDetailItem;
  isHost: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent([translations, locationTypeTranslations]);
  if (!props.event.payment) {
    return null;
  }
  return (
    <EventPaymentContainer>
      <PaymentDetail
        isNoBorder={true}
        isShowSchedule={false}
        isShowPaymentMethodOnly={
          props.event.payment.paymentMethod === PaymentMethod.Card
        }
        eventPayment={props.event.payment!}
        startDatetime={getDateTime(props.event.startedAt, props.event.timeZone)}
        endDatetime={getDateTime(props.event.endedAt, props.event.timeZone)}
        timeZone={props.event.timeZone}
        footer={
          <>
            <PaymentNote>{t('Payment Note')}</PaymentNote>
            <PaymentId>
              {t('Payment Id')} : {props.event.uid}
            </PaymentId>
            {!props.isHost && props.event.payment.receiptUrl && (
              <PaymentExternalLink
                href={props.event.payment.receiptUrl}
                target="_blank"
              >
                {t('Payment Recipt')}
              </PaymentExternalLink>
            )}
            {props.isHost && props.event.payment.stripePaymentIntentId && (
              <PaymentExternalLink
                href={stripeConnectPaymentIntentPath(
                  props.event.payment.stripePaymentIntentId,
                )}
                target="_blank"
              >
                {t('Payment Confirmation')}
              </PaymentExternalLink>
            )}
          </>
        }
      />
    </EventPaymentContainer>
  );
}

const EventPaymentContainer = styled.div`
  background-color: ${white};
  border-radius: 8px;
`;

const PaymentNote = styled.div`
  margin: ${spacing(12)} auto;
  color: ${gray01};
  font-size: ${fontSize(12)};
`;
const PaymentId = styled.span`
  padding-right: ${spacing(24)};
  color: ${black};
  font-size: ${fontSize(12)};
`;
const PaymentExternalLink = styled(Link)`
  border-left: 1px solid ${gray04};
  padding-left: ${spacing(24)};
  color: ${primary};
  font-size: ${fontSize(12)};
`;
